/**
 * Keeps the sticky add-to-cart bar in step with the Kaching Bundles deal the customer has
 * selected. The sticky button presses the main add-to-cart button, which adds the selected
 * deal, so the bar shows that deal's name and price instead of the first variant's.
 * Does nothing on products without a Kaching bundle.
 */
(function () {
  if (window.__stickyAtcBundle) return;
  window.__stickyAtcBundle = true;

  function hasBundle() {
    var settings = document.querySelector('script.kaching-bundles-deal-block-settings');
    // The theme's own "Coffrets" block (snippets/kg-bundle.liquid) works the same way.
    return (settings && settings.textContent.trim() !== '') || !!document.querySelector('.kgb');
  }

  function text(root, selector) {
    var el = root.querySelector(selector);
    return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function selectedDeal() {
    var option = document.querySelector('.kgb-option.is-selected');
    if (option) {
      return {
        title: text(option, '.kgb-option__title'),
        price: text(option, '.kgb-option__price'),
        fullPrice: text(option, '.kgb-option__compare'),
      };
    }
    var bar = document.querySelector('.kaching-bundles__bar--selected');
    if (!bar) {
      var checked = document.querySelector('.kaching-bundles__bar input:checked');
      bar = checked && checked.closest('.kaching-bundles__bar');
    }
    if (!bar) return null;
    var price = text(bar, '.kaching-bundles__bar-price');
    if (!price) return null;
    return {
      // Deal titles start with a colour emoji ("🔵 KREATIV-PAKET"); the narrow bar only needs the name.
      title: text(bar, '.kaching-bundles__bar-title').replace(/^[^\p{L}\p{N}]+/u, ''),
      price: price,
      fullPrice: text(bar, '.kaching-bundles__bar-full-price'),
    };
  }

  function setText(el, value) {
    if (el && el.textContent.trim() !== value) el.textContent = value;
  }

  function applyDeal(sticky, deal) {
    if (deal.title) {
      sticky.querySelectorAll('.sticky-atc-active-variant').forEach(function (variant) {
        var values = variant.querySelectorAll('.sticky-atc-active-variant__option-value');
        if (!values.length) return;
        setText(values[0], deal.title);
        values[0].setAttribute('data-bundle-deal', '');
        for (var i = 1; i < values.length; i++) values[i].closest('.sticky-atc-active-variant__option').hidden = true;
      });
    }

    var onSale = deal.fullPrice !== '' && deal.fullPrice !== deal.price;
    sticky.querySelectorAll('.sticky-atc-price .price').forEach(function (price) {
      price.classList.toggle('price--on-sale', onSale);
      price.querySelectorAll('.price__regular .price-item--regular').forEach(function (el) {
        setText(el, deal.price);
      });
      setText(price.querySelector('.price__sale .price-item--sale'), deal.price);
      setText(price.querySelector('.price__sale .price-item--strikethrough'), onSale ? deal.fullPrice : '');
    });
  }

  function init() {
    var sticky = document.querySelector('.sticky-atc');
    if (!sticky || !hasBundle()) return;

    var scheduled = false;
    var stickyObserver = new MutationObserver(schedule);
    var bundleObserver = new MutationObserver(schedule);

    function sync() {
      scheduled = false;
      var deal = selectedDeal();
      if (!deal) return;
      stickyObserver.disconnect();
      applyDeal(sticky, deal);
      stickyObserver.observe(sticky, { childList: true, subtree: true });
    }

    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(sync);
    }

    // The theme re-renders the sticky bar when the variant changes, so re-apply after it does.
    stickyObserver.observe(sticky, { childList: true, subtree: true });
    document.addEventListener('change', function (event) {
      if (event.target.closest && event.target.closest('.kaching-bundles, .kgb')) schedule();
    });

    // Kaching renders its block after load: wait for it, then watch it for a new selection.
    function watchBundle() {
      var block = document.querySelector('.kaching-bundles') || document.querySelector('.kgb');
      if (!block || !block.querySelector('.kaching-bundles__bar, .kgb-option')) return false;
      bundleObserver.observe(block, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true, characterData: true });
      schedule();
      return true;
    }

    if (watchBundle()) return;
    var waitObserver = new MutationObserver(function () {
      if (watchBundle()) waitObserver.disconnect();
    });
    waitObserver.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () {
      waitObserver.disconnect();
    }, 20000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
